"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setAssignmentProgress = exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _moment = _interopRequireDefault(require("moment"));
var _database = _interopRequireDefault(require("cccisd-icons/database"));
var _pencil = _interopRequireDefault(require("cccisd-icons/pencil7"));
var _play = _interopRequireDefault(require("cccisd-icons/play4"));
var _spinner = _interopRequireDefault(require("cccisd-icons/spinner11"));
var _spinner2 = _interopRequireDefault(require("cccisd-icons/spinner"));
var _info = _interopRequireDefault(require("cccisd-icons/info"));
var _cccisdWysiwyg = require("cccisd-wysiwyg");
var _helpers = require("../../../helpers.js");
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _CourseDescription = _interopRequireDefault(require("cccisd-laravel-assignment/dist/components/navigations/courseWrapper/Mediator/CourseDescription.js"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Boilerplate = window.cccisd.boilerplate;
var Fortress = window.cccisd.fortress;
var setAssignmentProgress = function setAssignmentProgress(resource) {
  var courseData = resource.courseData,
    childDeploymentData = resource.childDeploymentData,
    sharedRegistrationData = resource.sharedRegistrationData;
  var localAp = (0, _get2["default"])(courseData, 'assignmentProgress') || {};
  var isSharedRegistration = (0, _get2["default"])(courseData, 'assignment.settings.navigationSettings.registration.toggle', false) === true && (0, _get2["default"])(courseData, 'assignment.settings.navigationSettings.registration.isExternalRegistration', false) === true && !!(0, _get2["default"])(courseData, 'assignment.settings.navigationSettings.registration.externalRegistrationDeploymentId', false);
  var isSharedRegistrationComplete = (0, _get2["default"])(sharedRegistrationData, 'completed', false);

  // repeatable courses
  var isRepeated = (0, _get2["default"])(courseData, 'settings.isRepeated');
  if (isRepeated) {
    var cutoff = false;
    var repeatInterval = (0, _get2["default"])(courseData, 'settings.repeatInterval');
    if (repeatInterval) {
      var repeatIntervalParts = repeatInterval.split(' ').filter(function (item) {
        return item;
      });
      if (repeatIntervalParts.length === 2) {
        var repeatIntervalNumber = repeatIntervalParts[0];
        var repeatIntervalUnits = repeatIntervalParts[1];
        cutoff = (0, _moment["default"])().subtract(Number.parseInt(repeatIntervalNumber, 10), repeatIntervalUnits).format('YYYY-MM-DD HH:mm:ss');
      }
    }
    var certificate = (0, _get2["default"])(courseData, 'assignment.settings.navigationSettings.certificate', {}) || {};
    var isCourseResettable = (certificate === null || certificate === void 0 ? void 0 : certificate.toggle) && (certificate === null || certificate === void 0 ? void 0 : certificate.allowRenew) || (certificate === null || certificate === void 0 ? void 0 : certificate.forceRenewable);
    localAp = {
      started: false,
      completed: false
    };
    for (var i = childDeploymentData.length - 1; i >= 0; i--) {
      var dep = childDeploymentData[i];
      var isStarted = (0, _get2["default"])(dep, 'assignmentProgress.started', false);
      if (!isStarted) {
        continue;
      }
      var completedAt = (0, _get2["default"])(dep, 'assignmentProgress.completedAt', false);
      if (!completedAt || isCourseResettable) {
        localAp = dep.assignmentProgress;
        break;
      }
      if (cutoff && cutoff < completedAt) {
        localAp = dep.assignmentProgress;
        break;
      }
    }
  }
  var status = 'review';
  var borderColor = 'infoColor';
  if (!Fortress.auth() && courseData.type !== 'anon' || isSharedRegistration && !isSharedRegistrationComplete) {
    status = 'register';
    borderColor = 'warningColor';
  } else if (!localAp.started) {
    status = 'start';
    borderColor = 'primaryColor';
  } else if (!localAp.completed) {
    status = 'continue';
    borderColor = 'successColor';
  }
  if (!courseData.isOpen) {
    status = 'closed';
    borderColor = 'dangerColor';
  }
  return {
    localAp: localAp,
    status: status,
    borderColor: borderColor
  };
};
exports.setAssignmentProgress = setAssignmentProgress;
var Course = function Course(_ref) {
  var resource = _ref.resource;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    goToCourse = _useState2[0],
    setGoToCourse = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    goToCertificate = _useState4[0],
    setGoToCertificate = _useState4[1];
  var metadata = JSON.parse(resource.published_metadata) || {};
  var courseData = resource.courseData,
    localAp = resource.localAp;
  var aSettings = (0, _get2["default"])(courseData, 'assignment.settings') || {};
  var courseDescription = (0, _get2["default"])(aSettings, 'navigationSettings.courseDescription') || {};

  /* /////////////////////////////////////////////////////////////////////////
  // RENDER-RELATED /////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */

  function renderCreditHours() {
    if (!metadata.showCreditHours) {
      return null;
    }
    var creditHours = courseDescription.toggle && courseDescription.creditHours || {};

    // check for wysiwyg { content, meta } format
    var description = courseDescription.toggle && creditHours.description || 'Not available';
    if (description.content) {
      description = description.content;
    }
    var title = courseDescription.toggle && creditHours.title || 'Credit Hours';
    if (title.content) {
      title = title.content;
    }
    title += ':';
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].topSpace
    }, (!creditHours.icon || creditHours.icon === 'default') && /*#__PURE__*/_react["default"].createElement("span", {
      className: (0, _classnames["default"])(_style["default"].rightSpace, _style["default"].topSpace),
      style: {
        color: creditHours.iconColor || '#0361B0'
      }
    }, /*#__PURE__*/_react["default"].createElement(_database["default"], null)), creditHours.icon === 'upload' && creditHours.imageDetails && /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].backgroundImage,
      style: {
        backgroundImage: "url(".concat(creditHours.imageDetails.url, ")")
      }
    }), /*#__PURE__*/_react["default"].createElement("strong", {
      className: _style["default"].inline
    }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
      content: title
    })), ' ', /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].inline
    }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
      content: description
    })));
  }
  var renderDescription = resource.published_description ? /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].topSpace
  }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
    content: resource.published_description
  })) : null;
  function renderMainIntroduction() {
    var main = (0, _get2["default"])(courseDescription, 'introduction.main');
    if (!main || !metadata.showMainIntroduction) {
      return null;
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].topSpace
    }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
      content: main
    }));
  }
  function renderCourseSectionHeaders() {
    var sections = (0, _get2["default"])(courseDescription, 'introduction.courseSections') || [];
    var sectionsWithHeadings = sections.filter(function (section) {
      return section.heading;
    });
    if (!sectionsWithHeadings.length || !metadata.showCourseSectionHeaders) {
      return null;
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].topSpace
    }, /*#__PURE__*/_react["default"].createElement("ul", {
      className: "list-unstyled",
      style: {
        marginBottom: '5px'
      }
    }, sectionsWithHeadings.map(function (section, i) {
      return /*#__PURE__*/_react["default"].createElement("li", {
        key: section.key,
        className: "".concat(_style["default"].introductionSections, " ").concat(i % 2 === 0 ? _style["default"].grayBg : _style["default"].outline)
      }, /*#__PURE__*/_react["default"].createElement("h5", {
        style: {
          marginBottom: '0px'
        }
      }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
        content: "<b>".concat(section.heading, "</b>")
      })));
    })));
  }
  function renderCourseLink() {
    var btnDataArray = {
      closed: {
        "class": 'btn-danger',
        icon: _spinner2["default"],
        label: 'Coming Soon'
      },
      "continue": {
        "class": 'btn-success',
        icon: _play["default"],
        label: 'Continue'
      },
      register: {
        "class": 'btn-warning',
        icon: _pencil["default"],
        label: 'Register'
      },
      review: {
        "class": 'btn-info',
        icon: _spinner["default"],
        label: 'Review'
      },
      start: {
        "class": 'btn-primary',
        icon: _play["default"],
        label: 'Start'
      }
    };
    var btnData = btnDataArray[(0, _get2["default"])(resource, 'status', 'closed')];
    var ButtonIcon = btnData.icon;
    return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: (0, _classnames["default"])('btn', btnData["class"], !courseData.isOpen && 'disabled', _style["default"].topSpace, _style["default"].rightSpace),
      onClick: function onClick() {
        if (courseData.isOpen) {
          setGoToCourse(true);
        }
      }
    }, /*#__PURE__*/_react["default"].createElement(ButtonIcon, null), " ", btnData.label), metadata.showMoreInfoButton && /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
      trigger: /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: (0, _classnames["default"])('btn', 'btn-default', _style["default"].topSpace, _style["default"].rightSpace)
      }, /*#__PURE__*/_react["default"].createElement(_info["default"], null), ' ', metadata.moreInfoButtonTitle ? metadata.moreInfoButtonTitle : 'Learn More'),
      title: metadata.moreInfoButtonTitle ? metadata.moreInfoButtonTitle : 'Learn More',
      size: "large"
    }, /*#__PURE__*/_react["default"].createElement("div", null, metadata.moreInfoButtonContent ? /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
      content: metadata.moreInfoButtonContent
    }) : /*#__PURE__*/_react["default"].createElement(_CourseDescription["default"], {
      settings: aSettings.navigationSettings.courseDescription
    }))));
  }
  function renderCertificateLink() {
    if (!(0, _get2["default"])(aSettings, 'navigation', '').startsWith('courseWrapper') || !(0, _get2["default"])(aSettings, 'navigationSettings.certificate.toggle', false) || !localAp.completed) {
      return null;
    }
    return /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: (0, _classnames["default"])('btn btn-default', !courseData.isOpen && 'disabled', _style["default"].topSpace),
      onClick: function onClick() {
        if (courseData.isOpen) {
          setGoToCertificate(true);
        }
      }
    }, "View Certificate");
  }

  /* /////////////////////////////////////////////////////////////////////////
  // RENDER /////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */

  if (goToCertificate) {
    window.location.href = Boilerplate.url("/d/".concat(courseData.hash, "/").concat(Fortress.user.acting.respondent_hash, "/certificate"));
    return;
  }
  if (goToCourse) {
    if (metadata.courseCustomUrl) {
      if ((0, _helpers.isValidInternalLink)(metadata.courseCustomUrl)) {
        window.location.href = Boilerplate.url(metadata.courseCustomUrl);
        return null;
      }
      window.location.href = metadata.courseCustomUrl;
      return;
    }
    var respondentHash = (0, _get2["default"])(courseData, 'settings.requireLogin') || Fortress.user.acting.role.handle === 'guest' || courseData.type === 'anon' ? '' : "/".concat(Fortress.user.acting.respondent_hash);
    window.location.href = Boilerplate.url("/d/".concat(courseData.hash).concat(respondentHash));
    return;
  }
  if (!courseData.deploymentId) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "text-danger"
    }, "Course data not found");
  }
  return /*#__PURE__*/_react["default"].createElement("div", null, renderCreditHours(), renderDescription, renderMainIntroduction(), renderCourseSectionHeaders(), renderCourseLink(), renderCertificateLink());
};
Course.propTypes = {
  resource: _propTypes["default"].object.isRequired
};
var _default = Course;
exports["default"] = _default;